import { backgammonHeadData, spadesHeadData } from 'constants/headData';
import backgroundLOTB from '../assets/background_backgammon.jpg';
import backgroundSpades from '../assets/background_spades.jpg';
import logoLOTB from '../assets/logo/logo_backgammon.png';
import logoSpades from '../assets/logo/logo_spades.png';
import defaultBannerLOTB from '../assets/banner_backgammon.jpg';
import defaultBannerSpades from '../assets/banner_spades.jpg';
import iconSpades512x512 from '../assets/icons/spades_512x512.png';
import iconLOTB512x512 from '../assets/icons/bg_512x512.png';
import spadesGoods from 'assets/spades-goods/spadesGoods';
import backgammonGoods from 'assets/backgammon-goods/backgammonGoods';
import bgOfferBackground from 'assets/offer/offer-backgrounds_backgammon/backgammonOfferBacks';
import spadesOfferBackground from 'assets/offer/offer-backgrounds_spades/SpadesOfferBacks';

// The array stores objects with conditions that change depending on the game
export const appConfigPerGame = [
  {
    game: 'backgammon',
    background: backgroundLOTB,
    logo: logoLOTB,
    logoLeftIndent: '50px',
    isLoginWithCode: true,
    headData: backgammonHeadData,
    defaultBanner: defaultBannerLOTB,
    title: 'Lord Of The Board Store',
    icon_512x512: iconLOTB512x512,
    goodsAssets: backgammonGoods,
    offerBackground: bgOfferBackground,
  },

  {
    game: 'spades',
    background: backgroundSpades,
    logo: logoSpades,
    logoLeftIndent: '28px',
    isLoginWithCode: false,
    headData: spadesHeadData,
    defaultBanner: defaultBannerSpades,
    title: 'Spades Store',
    icon_512x512: iconSpades512x512,
    goodsAssets: spadesGoods,
    offerBackground: spadesOfferBackground,
  },
];
